import Header from "../../components/Header";
import { MascaraCpf } from "../../../utils/MascaraCpf";
import { MascaraTelefone } from "../../../utils/MascaraTelefone";
import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Typography, Breadcrumbs, Link, Button, Card, Divider, TextField, Autocomplete, MenuItem, Select, Checkbox, FormControlLabel, InputAdornment, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Box, FormControl, InputLabel, OutlinedInput, FormHelperText, } from "@mui/material";
import { Visibility, VisibilityOff, Email as EmailIcon, VerifiedUser as VerifiedUserIcon, } from "@mui/icons-material";
import { MascaraCnpj } from "../../../utils/MascaraCnpj";
import { TirarMascara } from "../../../utils/TirarMascara";
import { MascaraCep } from "../../../utils/MascaraCep";
import { FormatarData } from "../../../utils/FormatarData";
import ModalImage from "./ModalImage";
import { NumericFormat } from 'react-number-format';
import { useNavigate } from "react-router-dom";
import DeleteIcon from '@mui/icons-material/Delete';
import UploadFileIcon from "@mui/icons-material/UploadFile";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { MascaraCelular } from "../../../utils/MascaraCelular";
import servicesCode from "../../../data/ServicesCode";
import Switch from '@mui/material/Switch';
import ExpandMore from "@mui/icons-material/ExpandMore";
import ExpandLess from "@mui/icons-material/ExpandLess";
import FormLabel from '@mui/material/FormLabel';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { ptBR } from "date-fns/locale";


const estados = [
    "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA",
    "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN",
    "RS", "RO", "RR", "SC", "SP", "SE", "TO"
];

function PerfilUsuario(props) {
    const navigate = useNavigate();
    const { idUsuario } = useParams();

    const [showFichaCadastral, setShowFichaCadastral] = useState(false);
    const [showFichaDocumentos, setShowFichaDocumentos] = useState(false);
    const [showContratoSocial, setShowContratoSocial] = useState(false);
    const [contratoSocial, setContratoSocial] = useState(null);

    const [motivoRejeicaoRgCnh, setMotivoRejeicaoRgCnh] = useState("");
    const [motivoRejeicaoComprovanteEndereco, setMotivoRejeicaoComprovanteEndereco] = useState("");
    const [motivoRejeicaoTituloEleitor, setMotivoRejeicaoTituloEleitor] = useState("");

    const [fichaCadastral, setFichaCadastral] = useState({});
    const [fichaDocumentos, setFichaDocumentos] = useState({});
    const [userInfo, setUserInfo] = useState({});
    const [certificado, setCertificado] = useState({});
    const [empresa, setEmpresa] = useState({});
    const [servicos, setServicos] = useState([]);
    const [hasTomador, setHasTomador] = useState(false);
    const [certificadoLoading, setCertificadoLoading] = useState(false);
    const [servicoLoading, setServicoLoading] = useState(false);
    const [empresaLoading, setEmpresaLoading] = useState(false);
    const [notaLoading, setNotaLoading] = useState(false);
    const [limiteNotas, setLimiteNotas] = useState(0);
    const [qtdEmitidas, setQtdEmitidas] = useState(0);
    const token = localStorage.getItem('token');

    const [cnpjEmpresa, setCnpjEmpresa] = useState('');
    const [inscricaoEstadualEmpresa, setInscricaoEstadualEmpresa] = useState('');
    const [inscricaoMunicipalEmpresa, setInscricaoMunicipalEmpresa] = useState('');
    const [razaoSocialEmpresa, setRazaoSocialEmpresa] = useState('');
    const [nomeFantasiaEmpresa, setNomeFantasiaEmpresa] = useState('');
    const [emailEmpresa, setEmailEmpresa] = useState('');
    const [telefoneEmpresa, setTelefoneEmpresa] = useState('');
    const [celularEmpresa, setCelularEmpresa] = useState('');
    const [cepEmpresa, setCepEmpresa] = useState('');
    const [enderecoEmpresa, setEnderecoEmpresa] = useState('');
    const [numeroEmpresa, setNumeroEmpresa] = useState('');
    const [paisEmpresa, setPaisEmpresa] = useState('Brasil');
    const [estadoEmpresa, setEstadoEmpresa] = useState('');
    const [cidadeEmpresa, setCidadeEmpresa] = useState('');
    const [bairroEmpresa, setBairroEmpresa] = useState('');
    const [codigoIbgeEmpresa, setCodigoIbgeEmpresa] = useState('');
    const [regimeTributarioEmpresa, setRegimeTributarioEmpresa] = useState('');
    const [regimeTributarioEspecialEmpresa, setRegimeTributarioEspecialEmpresa] = useState('');
    const [regimeApuracaoTributariaEmpresa, setRegimeApuracaoTributariaEmpresa] = useState('');
    const [dataCompetencia, setDataCompetencia] = useState(new Date());
    const [alqSimplesNacional, setAlqSimplesNacional] = useState(0);

    const [serie, setSerie] = useState('');
    const [nextNumeroNota, setNextNumeroNota] = useState('');

    const [modalOpen, setModalOpen] = useState(false); // Estado para controlar o modal
    const [selectedImage, setSelectedImage] = useState(''); // Estado para armazenar a imagem selecionada
    const [showConfigAvancadaNfse, setShowConfigAvancadaNfse] = useState(false); // Estado para controlar a exibição da configuração avançada da NFS-e

    // Função para abrir o modal e definir a imagem selecionada
    const openModal = (imageUrl) => {
        setSelectedImage(imageUrl);
        setModalOpen(true);
    };

    // Função para fechar o modal
    const closeModal = () => {
        setModalOpen(false);
        setSelectedImage(''); // Limpar a imagem selecionada
    };

    useEffect(() => {
        const getInfoUsuario = async () => {
            const responseUser = await axios.get(`${process.env.REACT_APP_API_URL}/getInfoPerfilUsuario/${idUsuario}`, {
                headers: {
                    Authorization: localStorage.getItem('token')
                }
            });

            if (responseUser.data.status !== 200) {
                alert("Erro ao buscar informações do usuário.");
                return;
            }
            console.log(responseUser.data.dados);
            setUserInfo(responseUser.data.dados.usuario);
            setCertificado(responseUser.data.dados.certificado);
            setEmpresa(responseUser.data.dados.empresa);
            setServicos(responseUser.data.dados.servicos);
            if (responseUser.data.dados.assinatura) {
                setLimiteNotas(responseUser.data.dados.assinatura.plano.qtdNfseMensalClarea);
            }
            setQtdEmitidas(responseUser.data.dados.notasEmitidasbyClarea);

            setCnpjEmpresa(responseUser.data.dados.empresa.cnpj);
            setEnderecoEmpresa(responseUser.data.dados.empresa.endereco);
            setInscricaoEstadualEmpresa(responseUser.data.dados.empresa.inscricaoEstadual);
            setInscricaoMunicipalEmpresa(responseUser.data.dados.empresa.inscricaoMunicipal);
            setRazaoSocialEmpresa(responseUser.data.dados.empresa.razaoSocial);
            setNomeFantasiaEmpresa(responseUser.data.dados.empresa.nomeFantasia);
            setRegimeTributarioEmpresa(responseUser.data.dados.empresa.taxRegime);
            setRegimeTributarioEspecialEmpresa(responseUser.data.dados.empresa.specialTaxRegime);
            setRegimeApuracaoTributariaEmpresa(responseUser.data.dados.empresa.simplesNacionalTaxRegime);
            setCelularEmpresa(responseUser.data.dados.empresa.celular);
            setCepEmpresa(responseUser.data.dados.empresa.cep);
            setNumeroEmpresa(responseUser.data.dados.empresa.numero);
            setEstadoEmpresa(responseUser.data.dados.empresa.estado);
            setCidadeEmpresa(responseUser.data.dados.empresa.cidade);
            setBairroEmpresa(responseUser.data.dados.empresa.bairro);
            setEmailEmpresa(responseUser.data.dados.empresa.email);
            setTelefoneEmpresa(responseUser.data.dados.empresa.telefone);
            setCodigoIbgeEmpresa(responseUser.data.dados.empresa.codigoIbge);

            setSerie(responseUser.data.dados.empresa.series);
            setNextNumeroNota(responseUser.data.dados.empresa.nextNumber);
        }

        getInfoUsuario();
    }, [idUsuario, certificadoLoading, servicoLoading, empresaLoading, notaLoading]);

    const [isDragging, setIsDragging] = useState(false);
    const [file, setFile] = useState(null);
    const [senha, setSenha] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [codigo, setCodigo] = useState("");
    const fileInputRef = useRef(null);

    const [servicoASerAdicionado, setServicoASerAdicionado] = useState({});

    // Funções de drag and drop
    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = () => setIsDragging(false);

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        const droppedFile = e.dataTransfer.files[0];
        validateFile(droppedFile);
    };

    const handleFileSelect = (e) => {
        const selectedFile = e.target.files[0];
        validateFile(selectedFile);
    };

    const validateFile = (file) => {
        if (file && (file.name.endsWith(".pfx") || file.name.endsWith(".p12"))) {
            setFile(file);
        } else {
            alert("Por favor, selecione um arquivo .pfx ou .p12 válido.");
        }
    };

    // Controle da visibilidade da senha
    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => event.preventDefault();

    const handleSaveUserInfo = () => {
        console.log("Salvar informações do usuário:", userInfo);
    }

    const handleSaveCertificado = async () => {
        if (!file) return alert("Selecione um arquivo de certificado.");
        if (!senha) return alert("Digite a senha do certificado.");

        const formData = new FormData();
        formData.append("arquivo", file);
        formData.append("senha", senha);
        formData.append("email", userInfo.Email);
        formData.append("idUsuario", idUsuario);

        try {
            setCertificadoLoading(true);
            const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/uploadCertificadoADM`, formData, {
                headers: {
                    Authorization: token,
                    "Content-Type": "multipart/form-data",
                },
            });
            console.log("Resposta do upload:", data);
            if (data.status === 200) {
                alert("Certificado atualizado com sucesso!");
            } else {
                alert("Falha ao atualizar certificado. Verifique os dados e tente novamente.");
            }
        } catch (err) {
            console.error(err);
            alert("Erro ao enviar o certificado. Tente novamente mais tarde.");
        } finally {
            setCertificadoLoading(false);
        }
    }

    const handleSaveServico = async () => {

        if (!servicoASerAdicionado || !servicoASerAdicionado.code) {
            alert("Selecione um serviço válido para adicionar.");
            return;
        }
        try {
            setServicoLoading(true);
            await axios.post(`${process.env.REACT_APP_API_URL}/adicionarServicoADM`, {
                idUsuario: Number(idUsuario),
                codigo: servicoASerAdicionado.code,
                discriminacao: servicoASerAdicionado.description,
            }, {
                headers: {
                    Authorization: token,
                },
            });
        } catch (err) {
            console.error(err);
            alert("Erro ao adicionar serviço. Tente novamente mais tarde.");
        } finally {
            setServicoLoading(false);
            setServicoASerAdicionado({}); // Limpa o serviço selecionado após a adição
        }

    }

    // const [servicoSelecionado, setServicoSelecionado] = useState(null);
    const [valorServico, setValorServico] = useState('0');
    // const [descontoCondicionado, setDescontoCondicionado] = useState('0');
    // const [descontoIncondicionado, setDescontoIncondicionado] = useState('0');
    // const [regimeApuracaoTributaria, setRegimeApuracaoTributaria] = useState('');
    const [descricaoDoServico, setDescricaoDoServico] = useState('');
    const [deducoes, setDeducoes] = useState('');
    const [valorLiquido, setValorLiquido] = useState('');
    const [baseCalculo, setBaseCalculo] = useState('');

    const [impostoIssAlq, setImpostoIssAlq] = useState('');
    const [impostoIssValor, setImpostoIssValor] = useState('');

    const [impostoPisAlq, setImpostoPisAlq] = useState('');
    const [impostoPisValor, setImpostoPisValor] = useState('');

    const [impostoCofinsAlq, setImpostoCofinsAlq] = useState('');
    const [impostoCofinsValor, setImpostoCofinsValor] = useState('');

    const [impostoCsllAlq, setImpostoCsllAlq] = useState('');
    const [impostoCsllValor, setImpostoCsllValor] = useState('');

    const [impostoIrAlq, setImpostoIrAlq] = useState('');
    const [impostoIrValor, setImpostoIrValor] = useState('');

    const [impostoInssAlq, setImpostoInssAlq] = useState('');
    const [impostoInssValor, setImpostoInssValor] = useState('');

    const [reterIss, setReterIss] = useState(false);
    const [valorIssRetido, setValorIssRetido] = useState('');

    const [reterPis, setReterPis] = useState(false);
    const [valorPisRetido, setValorPisRetido] = useState('');

    const [reterCofins, setReterCofins] = useState(false);
    const [valorCofinsRetido, setValorCofinsRetido] = useState('');

    const [reterCsll, setReterCsll] = useState(false);
    const [valorCsllRetido, setValorCsllRetido] = useState('');

    const [reterIr, setReterIr] = useState(false);
    const [valorIrRetido, setValorIrRetido] = useState('');

    const [reterInss, setReterInss] = useState(false);
    const [valorInssRetido, setValorInssRetido] = useState('');

    const [cpfCnpjTomador, setCpfCnpjTomador] = useState('');
    const [razaoSocialTomador, setRazaoSocialTomador] = useState('');
    const [emailTomador, setEmailTomador] = useState('');
    const [cepTomador, setCepTomador] = useState('');
    const [enderecoTomador, setEnderecoTomador] = useState('');
    const [numeroTomador, setNumeroTomador] = useState('');
    const [estadoTomador, setEstadoTomador] = useState('');
    const [cidadeTomador, setCidadeTomador] = useState('');
    const [bairroTomador, setBairroTomador] = useState('');
    const [telefoneTomador, setTelefoneTomador] = useState('');
    const [nomeTomador, setNomeTomador] = useState('');
    const [paisTomador, setPaisTomador] = useState('');
    const [codigoIbgeTomador, setCodigoIbgeTomador] = useState('');



    const handleEmitirNota = async () => {
        const formatarValor = (valor) => {
            return Number(valor.replace("R$ ", "").replace(/\./g, "").replace(",", "."));
        };

        console.log(Number((Number(valorServico.replace(/\./g, '').replace(',', '.')) * 10).toFixed(2)));

        if (hasTomador) {
            if (!cpfCnpjTomador) {
                alert('Por favor, preencha todos os dados do tomador.');
                return;
            }
        }

        if (!codigo) {
            alert('Por favor, selecione um serviço.');
            return;
        }

        if (!descricaoDoServico) {
            alert('Por favor, informe a descrição do serviço.');
            return;
        }

        if (!valorServico || formatarValor(valorServico) <= 0) {
            alert('Por favor, informe um valor de serviço válido.');
            return;
        }

        const body = {
            idUsuario: Number(idUsuario),
            dataCompetencia: dataCompetencia.toISOString(),
            tomador: {
                name: hasTomador ? nomeTomador : null,
                federalTaxNumber: hasTomador ? TirarMascara(cpfCnpjTomador) : null,
                email: hasTomador ? emailTomador : null,
                phoneNumber: hasTomador ? TirarMascara(telefoneTomador) : null,
                address: {
                    street: hasTomador ? enderecoTomador : null,
                    district: hasTomador ? bairroTomador : null,
                    postalCode: hasTomador ? TirarMascara(cepTomador) : null,
                    number: hasTomador ? numeroTomador : null,
                    city: {
                        name: hasTomador ? cidadeTomador : null,
                        state: hasTomador ? estadoTomador : null,
                        code: hasTomador ? codigoIbgeTomador : null
                    },
                    country: hasTomador ? "BRA" : null
                }
            },
            total: {
                valorServico: formatarValor(valorServico),
                valorLiquido: formatarValor(valorLiquido),
                alqIss: impostoIssAlq ? formatarValor(impostoIssAlq) : 0,
                valorIss: impostoIssValor ? formatarValor(impostoIssValor) : 0,
                alqPis: impostoPisAlq ? formatarValor(impostoPisAlq) : 0,
                valorPis: impostoPisValor ? formatarValor(impostoPisValor) : 0,
                alqCofins: impostoCofinsAlq ? formatarValor(impostoCofinsAlq) : 0,
                valorCofins: impostoCofinsValor ? formatarValor(impostoCofinsValor) : 0,
                alqCsll: impostoCsllAlq ? formatarValor(impostoCsllAlq) : 0,
                valorCsll: impostoCsllValor ? formatarValor(impostoCsllValor) : 0,
                alqIr: impostoIrAlq ? formatarValor(impostoIrAlq) : 0,
                valorIr: impostoIrValor ? formatarValor(impostoIrValor) : 0,
                alqInss: impostoInssAlq ? formatarValor(impostoInssAlq) : 0,
                valorInss: impostoInssValor ? formatarValor(impostoInssValor) : 0,
                reterIss,
                valorIssRetido: valorIssRetido ? formatarValor(valorIssRetido) : 0,
                reterPis,
                valorPisRetido: valorPisRetido ? formatarValor(valorPisRetido) : 0,
                reterCofins,
                valorCofinsRetido: valorCofinsRetido ? formatarValor(valorCofinsRetido) : 0,
                reterCsll,
                valorCsllRetido: valorCsllRetido ? formatarValor(valorCsllRetido) : 0,
                reterIr,
                valorIrRetido: valorIrRetido ? formatarValor(valorIrRetido) : 0,
                reterInss,
                valorInssRetido: valorInssRetido ? formatarValor(valorInssRetido) : 0,
            },
            approximateTaxes: {
                simplesNacionalRate: alqSimplesNacional ? formatarValor(alqSimplesNacional) : 0,
                mode: "simplified"
            },
            descricaoDoServico,
            codigo,
            hasTomador
        };
        setNotaLoading(true);
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/emitirNotaServicoADM`, body, {
            headers: {
                Authorization: localStorage.getItem('token'),
                'Content-Type': 'application/json'
            }
        });
        console.log(response.data);
        if (response.data.status === 200) {
            setNotaLoading(false);
            alert('Nota fiscal emitida com sucesso!');
            setCodigo('');
            setDescricaoDoServico('');
            setValorServico('');
            setValorLiquido('');
            setBaseCalculo('');
            setReterIr(false);
            setValorIrRetido('');
            setAlqSimplesNacional('');
        } else {
            setNotaLoading(false);
            alert('Erro ao emitir nota fiscal: ' + response.data);
        }
    }

    const handleCepTomador = async (e) => {
        let value = TirarMascara(e.target.value.slice(0, 9));
        setCepTomador(value);
        console.log("CEP do tomador alterado para:", value);
        if (value.length === 8) {
            console.log("Buscando endereço para CEP:", value);
            try {
                const response = await axios.get(`https://viacep.com.br/ws/${value}/json/`);
                console.log("Endereço encontrado:", response.data);
                setEnderecoTomador(response.data.logradouro || '');
                setCidadeTomador(response.data.localidade || '');
                setEstadoTomador(response.data.uf.toLowerCase() || '');
                setBairroTomador(response.data.bairro || '');
                setCodigoIbgeTomador(response.data.ibge || '');
                setPaisTomador('Brasil'); // Definindo o país como Brasil
            } catch (error) {
                setEnderecoTomador('');
                setCidadeTomador('');
                setEstadoTomador('');
                setBairroTomador('');
                setCodigoIbgeTomador('');
                setPaisTomador('');
                alert("Erro ao buscar endereço para o CEP informado. Verifique se o CEP é válido.");
                console.error("Erro ao buscar endereço:", error);
            }
        }
    }

    const handleCepChange = async (e) => {
        let value = TirarMascara(e.target.value);
        setCepEmpresa(value);
        if (value.length === 8) {
            console.log("Buscando endereço para CEP:", value);
            try {
                const response = await axios.get(`https://viacep.com.br/ws/${value}/json/`);
                console.log("Endereço encontrado:", response.data);
                setEnderecoEmpresa(response.data.logradouro || '');
                setCidadeEmpresa(response.data.localidade || '');
                setEstadoEmpresa(response.data.uf.toLowerCase() || '');
                setBairroEmpresa(response.data.bairro || '');
                setCodigoIbgeEmpresa(response.data.ibge || '');
            } catch (error) {
                alert("Erro ao buscar endereço para o CEP informado. Verifique se o CEP é válido.");
                console.error("Erro ao buscar endereço:", error);
            }
        }
    }

    const handleSaveCompanyConfig = async () => {
        let isValid = true;

        if (!serie) {
            isValid = false;
            alert("Série é obrigatória.");
            return;
        }

        if (!nextNumeroNota) {
            isValid = false;
            alert("Número do próximo RPS/DPS ou NFs-e é obrigatório.");
            return;
        }

        if (isValid) {
            const body = {
                idUsuario,
                serie,
                nextNumeroNota,
            };

            try {
                setEmpresaLoading(true);
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/salvarConfiguracoesEmpresaADM`, body, {
                    headers: {
                        Authorization: token,
                        'Content-Type': 'application/json'
                    }
                });
                if (response.data.status === 200) {
                    alert("Configurações da empresa atualizadas com sucesso!");
                } else {
                    alert("Erro ao atualizar configurações da empresa: " + response.data.message);
                }
            } catch (error) {
                console.error("Erro ao atualizar configurações da empresa:", error);
                alert("Não foi possível atualizar as configurações da empresa. Tente novamente mais tarde.");
            } finally {
                setEmpresaLoading(false);
            }
        }
    }

    const handleSaveCompany = async () => {
        let isValid = true;

        if (!nomeFantasiaEmpresa) {
            isValid = false;
            alert("Nome Fantasia é obrigatório.");
            return;
        }

        if (!razaoSocialEmpresa) {
            isValid = false;
            alert("Razão Social é obrigatória.");
            return;

        }

        if (cnpjEmpresa?.length !== 14) {
            isValid = false;
            alert("CNPJ inválido.");
            return;

        }

        if (!enderecoEmpresa) {
            isValid = false;
            alert("Endereço é obrigatório.");
            return;

        }

        if (!bairroEmpresa) {
            isValid = false;
            alert("Bairro é obrigatório.");
            return;

        }

        if (cepEmpresa?.length !== 8) {
            isValid = false;
            alert("CEP inválido.");
            return;

        }

        if (!estadoEmpresa) {
            isValid = false;
            alert("Estado é obrigatório.");
            return;

        }

        if (!cidadeEmpresa) {
            isValid = false;
            alert("Cidade é obrigatória.");
            return;

        }

        if (!numeroEmpresa) {
            isValid = false;
            alert("Número do endereço é obrigatório.");
            return;
        }

        if (isValid) {
            const body = {
                idUsuario,
                nomeFantasiaEmpresa,
                razaoSocialEmpresa,
                cnpjEmpresa,
                inscricaoEstadualEmpresa,
                inscricaoMunicipalEmpresa,
                emailEmpresa,
                telefoneEmpresa,
                celularEmpresa,
                endereco: {
                    enderecoEmpresa,
                    bairroEmpresa,
                    cepEmpresa,
                    numeroEmpresa,
                },
                cidade: {
                    codigoIbge: codigoIbgeEmpresa, // Aqui você pode adicionar o código IBGE da cidade, se disponível
                    nome: cidadeEmpresa,
                    state: estadoEmpresa,
                },
                pais: {
                    nome: paisEmpresa,
                },
                taxRegime: regimeTributarioEmpresa,
                specialTaxRegime: regimeTributarioEspecialEmpresa,
                simplesNacionalTaxRegime: regimeApuracaoTributariaEmpresa,
            };

            try {
                setEmpresaLoading(true);
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/salvarDadosEmpresaADM`, body, {
                    headers: {
                        Authorization: token,
                        'Content-Type': 'application/json'
                    }
                });
                if (response.data.status === 200) {
                    alert("Informações da empresa atualizadas com sucesso!");
                } else {
                    alert("Erro ao atualizar informações da empresa: " + response.data.message);
                }
            } catch (error) {
                console.error("Erro ao atualizar informações da empresa:", error);
                alert("Não foi possível atualizar as informações da empresa. Tente novamente mais tarde.");
            } finally {
                setEmpresaLoading(false);
            }
        }
    }

    const handleCnpjTomador = async (e) => {
        let value = e.target.value;
        if (!value) return;

        const somenteNumeros = value.replace(/\D/g, "");

        // CPF até 11 dígitos | CNPJ até 14 dígitos
        if (somenteNumeros.length <= 11) {
            setCpfCnpjTomador(MascaraCpf(value));
            return;
        }

        // Caso seja CNPJ
        setCpfCnpjTomador(MascaraCnpj(value));
    };

    const handleDownload = (tipo, cnpj) => {
        // Ex: tipo = "pdf" ou "xml"
        const url = `${process.env.REACT_APP_API_URL}/download/${tipo}/${cnpj}`;
        window.open(url, "_blank");
    };

    useEffect(() => {
        const getFichaCadastral = async () => {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/getFichaCadastralADM/${idUsuario}`, {
                headers: {
                    Authorization: token
                }
            });

            setFichaCadastral(response.data.ficha);
            const documentos = await axios.get(`${process.env.REACT_APP_API_URL}/getDocumentosUsuarioADM/${idUsuario}`, {
                headers: {
                    Authorization: token
                }
            });
            console.log(documentos.data.documentos);
            setFichaDocumentos(documentos.data.documentos);
        }

        getFichaCadastral();
    }, [idUsuario, token]);


    const handleRejeitarDoc = async (tipoDoc) => {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/rejeitarDocumentoADM/${tipoDoc}`, {
            idUsuario: Number(idUsuario),
            motivoRejeicao: tipoDoc === "rgCnh" ? motivoRejeicaoRgCnh : tipoDoc === "comprovanteEndereco" ? motivoRejeicaoComprovanteEndereco : motivoRejeicaoTituloEleitor
        }, {
            headers: {
                Authorization: token
            }
        });
        console.log(response.data);
        setFichaDocumentos(response.data.documentos);

    }

    const handleAceitarDoc = async (tipoDoc) => {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/aceitarDocumentoADM/${tipoDoc}`, {
            idUsuario: Number(idUsuario),
            motivoRejeicao: tipoDoc === "rgCnh" ? motivoRejeicaoRgCnh : tipoDoc === "comprovanteEndereco" ? motivoRejeicaoComprovanteEndereco : motivoRejeicaoTituloEleitor
        }, {
            headers: {
                Authorization: token
            }
        });
        console.log("ficha documentos: ", response.data);
        setFichaDocumentos(response.data.documentos);
    }

    const handleDeleteService = async (servico) => {
        console.log(servico);
        try {
            setServicoLoading(true);
            await axios.delete(
                `${process.env.REACT_APP_API_URL}/deletarServicoADM`,
                {
                    headers: {
                        authorization: token,
                    },
                    data: {
                        idServico: servico.idServico,
                    },
                }
            ).then((response) => {
                if (response.data.status === 200) {
                } else {
                    console.error("Erro ao deletar serviço:", response.data);
                    alert("Falha ao deletar serviço. Tente novamente.");
                }
            })

        } catch (err) {
            console.error(err);
            alert("Erro ao deletar serviço. Tente novamente mais tarde.");
        } finally {
            setServicoLoading(false);
        }
    }

    const enviarContratoSocial = async () => {
        try {
            if (!contratoSocial) {
                alert("Selecione um arquivo antes de enviar.");
                return;
            }

            const formData = new FormData();

            formData.append("contratoSocial", contratoSocial);
            formData.append("userId", Number(idUsuario));

            const response = await axios.post(`${process.env.REACT_APP_API_URL}/contrato-social/upload`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": token,
                },
            });

            alert("Contrato enviado com sucesso!");
            setShowContratoSocial(false);
            setContratoSocial(null);

            console.log(response.data);
        } catch (error) {
            console.error(error);

            alert(
                error.response?.data?.message ||
                "Erro ao enviar o contrato social."
            );
        }
    };

    const handleDeducoesChange = (e) => {
        const value = e.target.value;

        const parseCurrency = (valor) => {
            if (!valor) return 0;

            return Number(
                valor
                    .replace("R$ ", "")
                    .replace(/\./g, "")
                    .replace(",", ".")
            );
        };

        const valorServicoNumber = parseCurrency(valorServico);
        let deducoesNumber = parseCurrency(value);

        // Não permite dedução maior que o valor do serviço
        if (deducoesNumber > valorServicoNumber) {
            alert("Deduções não podem ser maiores que o valor do serviço.");
            deducoesNumber = 0;
        }

        const baseCalculoNumber = Math.max(
            valorServicoNumber - deducoesNumber,
            0
        );

        setDeducoes(
            deducoesNumber.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
            })
        );

        setBaseCalculo(
            baseCalculoNumber.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
            })
        );

        setValorLiquido(
            (valorServicoNumber).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
            })
        );
        setImpostoIssValor('');
        setImpostoIssAlq('');

        setImpostoPisValor('');
        setImpostoPisAlq('');

        setImpostoCofinsAlq('');
        setImpostoCofinsValor('');

        setImpostoCsllAlq('');
        setImpostoCsllValor('');

        setImpostoIrAlq('');
        setImpostoIrValor('');

        setImpostoInssAlq('');
        setImpostoInssValor('');
    };


    // const moedaParaNumero = (valor = "") => {
    //     return Number(
    //         valor
    //             .toString()
    //             .replace("R$", "")
    //             .replace(/\s/g, "")
    //             .replace(/\./g, "")
    //             .replace(",", ".")
    //     ) || 0;
    // };

    // const handleCalcularImposto = (alq) => {
    //     const numeroAliquota = Number(
    //         alq?.toString().replace(",", ".")
    //     ) || 0;

    //     const baseCalculoNumber = moedaParaNumero(baseCalculo);

    //     console.log({
    //         alq,
    //         numeroAliquota,
    //         baseCalculo,
    //         baseCalculoNumber,
    //     });

    //     return (baseCalculoNumber * (numeroAliquota / 100)).toFixed(2).replace(".", ",");
    // };

    const handleShowInformation = () => {
        setShowConfigAvancadaNfse(!showConfigAvancadaNfse)

        setImpostoIssAlq('');
        setImpostoIssValor('');

        setImpostoPisAlq('');
        setImpostoPisValor('');

        setImpostoCofinsAlq('');
        setImpostoCofinsValor('');

        setImpostoCsllAlq('');
        setImpostoCsllValor('');

        setImpostoIrAlq('');
        setImpostoIrValor('');

        setImpostoInssAlq('');
        setImpostoInssValor('');

        setReterIss(false);
        setValorIssRetido('');

        setReterPis(false);
        setValorPisRetido('');

        setReterCofins(false);
        setValorCofinsRetido('');

        setReterCsll(false);
        setValorCsllRetido('');

        setReterIr(false);
        setValorIrRetido('');

        setReterInss(false);
        setValorInssRetido('');

    }

    const handleIrChange = (e) => {

        const moedaParaNumero = (valor = "") => {
            return Number(
                valor
                    .toString()
                    .replace("R$", "")
                    .replace(/\s/g, "")
                    .replace(/\./g, "")
                    .replace(",", ".")
            ) || 0;
        };

        setValorIrRetido(e.target.value);
        setValorLiquido((moedaParaNumero(baseCalculo) - moedaParaNumero(e.target.value)).toFixed(2).replace('.', ','));
    }

    return (
        <div>
            <Header />
            <div style={{ width: '100%', height: '90vh', display: 'flex', justifyContent: 'center' }}>
                <div style={{ width: '90%', marginTop: 20 }}>
                    <div role="presentation">
                        <Breadcrumbs aria-label="breadcrumb">
                            <Link underline="hover" color="inherit" onClick={() => navigate("../dashboard")}>
                                Dashboard
                            </Link>
                            <Link underline="hover" color="inherit" onClick={() => navigate("../emitirNota")}>
                                Emitir Nota
                            </Link>
                            <Typography sx={{ color: 'text.primary' }}>Perfil Usuário</Typography>
                        </Breadcrumbs>
                    </div>
                    <div>
                        <h2>Perfil do Usuário {userInfo?.Nome || ""}</h2>
                    </div>
                    <div>
                        <h3>Dados do Usuário</h3>
                    </div>
                    <div style={{ width: "100%", overflowX: "auto", marginTop: "20px", display: "flex", justifyContent: "center" }}>
                        <div style={{ width: "90%", overflowX: "auto", marginTop: "20px", display: "flex", justifyContent: "center", gap: "50px", flexDirection: "column", paddingBottom: "50px" }}>
                            <Card
                                sx={{
                                    width: "100%",
                                    borderRadius: "5px",
                                    backgroundColor: "#f7f7f7ff",
                                }}
                            >
                                <div style={{ padding: "15px" }}>
                                    <h2>Baixar Documentos Fiscais</h2>
                                </div>

                                <Divider />

                                <div
                                    style={{
                                        padding: "15px",
                                        backgroundColor: "#ffffff",
                                        borderRadius: "0 0 5px 5px",
                                        marginTop: "20px",
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        gap: "10px",
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        size="small"
                                        sx={{
                                            backgroundColor: "#0b243d",
                                            "&:hover": { backgroundColor: "#153d66" },
                                            textTransform: "none",
                                        }}
                                        onClick={() => handleDownload("pdf", cnpjEmpresa)}
                                    >
                                        Baixar PDFs
                                    </Button>

                                    <Button
                                        variant="contained"
                                        size="small"
                                        sx={{
                                            backgroundColor: "#00695c",
                                            "&:hover": { backgroundColor: "#00897b" },
                                            textTransform: "none",
                                        }}
                                        onClick={() => handleDownload("xml", cnpjEmpresa)}
                                    >
                                        Baixar XMLs
                                    </Button>
                                </div>
                            </Card>

                            <Card style={{ width: "100%", borderRadius: "5px", backgroundColor: "#f7f7f7ff" }}>
                                <div style={{ padding: "15px", width: "100%", borderRadius: "5px", backgroundColor: "#f7f7f7ff", cursor: "pointer" }} onClick={() => {
                                    if (showContratoSocial) {
                                        setShowContratoSocial(false)
                                    } else {
                                        setShowContratoSocial(true)
                                    }
                                }}>
                                    <h2>Contrato Social</h2>
                                    <p>{fichaDocumentos.contratoSocialFileName ? <span style={{ color: "green" }}>Contrato Social enviado</span> : <span style={{ color: "red" }}>Contrato Social não enviado</span>}</p>
                                </div>
                                <Divider />
                                <div style={{ padding: "15px", display: showContratoSocial ? "block" : "none", transition: "all 0.3s ease-in-out" }}>
                                    <span>Você pode enviar o Contrato Social clicando no botão abaixo, para sobrescrever o arquivo existente.</span>
                                </div>
                                <div
                                    style={{
                                        padding: "15px",
                                        display: showContratoSocial ? "block" : "none",
                                        transition: "all 0.3s ease-in-out",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            border: "2px dashed #d0d5dd",
                                            borderRadius: 3,
                                            p: 3,
                                            bgcolor: "#fafafa",
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            gap: 2,
                                            transition: ".3s",
                                            "&:hover": {
                                                borderColor: "#1976d2",
                                                bgcolor: "#f5f9ff",
                                            },
                                        }}
                                    >
                                        <UploadFileIcon
                                            sx={{
                                                fontSize: 55,
                                                color: "#1976d2",
                                            }}
                                        />

                                        <Typography fontWeight={600} fontSize={18}>
                                            Contrato Social
                                        </Typography>

                                        <Typography
                                            variant="body2"
                                            color="text.secondary"
                                            textAlign="center"
                                        >
                                            Selecione um arquivo em PDF para anexar.
                                        </Typography>

                                        <input
                                            accept="application/pdf"
                                            id="upload-contrato-social"
                                            type="file"
                                            hidden
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file) {
                                                    setContratoSocial(file);
                                                }
                                            }}
                                        />

                                        <label htmlFor="upload-contrato-social">
                                            <Button
                                                component="span"
                                                variant="outlined"
                                                startIcon={<UploadFileIcon />}
                                                sx={{
                                                    borderRadius: 2,
                                                    textTransform: "none",
                                                    px: 3,
                                                }}
                                            >
                                                Escolher PDF
                                            </Button>
                                        </label>

                                        {contratoSocial && (
                                            <Box
                                                sx={{
                                                    width: "100%",
                                                    mt: 1,
                                                    p: 2,
                                                    borderRadius: 2,
                                                    bgcolor: "#fff",
                                                    border: "1px solid #e0e0e0",
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <Box display="flex" alignItems="center" gap={1.5}>
                                                    <PictureAsPdfIcon
                                                        sx={{
                                                            color: "#d32f2f",
                                                            fontSize: 35,
                                                        }}
                                                    />

                                                    <Box>
                                                        <Typography fontWeight={600}>
                                                            {contratoSocial.name}
                                                        </Typography>

                                                        <Typography
                                                            variant="caption"
                                                            color="text.secondary"
                                                        >
                                                            {(contratoSocial.size / 1024 / 1024).toFixed(2)} MB
                                                        </Typography>
                                                    </Box>
                                                </Box>

                                                <Button
                                                    variant="contained"
                                                    color="success"
                                                    onClick={enviarContratoSocial}
                                                    disabled={!contratoSocial}
                                                    sx={{
                                                        borderRadius: 2,
                                                        textTransform: "none",
                                                    }}
                                                >
                                                    Enviar
                                                </Button>
                                            </Box>
                                        )}
                                    </Box>
                                </div>
                            </Card>

                            <Card style={{ width: "100%", borderRadius: "5px", backgroundColor: "#f7f7f7ff" }}>
                                <div style={{ padding: "15px", width: "100%", borderRadius: "5px", backgroundColor: "#f7f7f7ff", cursor: "pointer" }} onClick={() => {
                                    if (showFichaCadastral) {
                                        setShowFichaCadastral(false)
                                    } else {
                                        setShowFichaCadastral(true)
                                    }
                                }}>
                                    <h2>Ficha Cadastral</h2>
                                    <p>{fichaCadastral?.ficha?.progress === 100 ? <p style={{ color: "green" }}>Usuário preencheu todos os campos obrigatórios</p> : <p style={{ color: "red" }}>Usuário não preencheu todos os campos obrigatórios</p>}</p>
                                </div>
                                <Divider />
                                <div style={{ padding: "15px", display: showFichaCadastral ? "block" : "none", transition: "all 0.3s ease-in-out" }}>
                                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between", gap: "15px" }}>
                                        <TextField label="Data nascimento" sx={{ width: "48%" }} variant="standard" value={FormatarData(fichaCadastral?.ficha?.dataNascimento) || ''} />
                                        <TextField label="RG" sx={{ width: "48%" }} variant="standard" value={fichaCadastral?.ficha?.rg || ''} />
                                    </div>
                                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between", gap: "15px", marginTop: "15px" }}>
                                        <TextField label="Orgão RG" sx={{ width: "48%" }} variant="standard" value={fichaCadastral?.ficha?.orgaoRg || ''} />
                                        <TextField label="Título Eleitor" sx={{ width: "48%" }} variant="standard" value={fichaCadastral?.ficha?.tituloEleitor || ''} />
                                    </div>
                                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between", gap: "15px", marginTop: "15px" }}>
                                        <TextField label="PIS/NIS/NIT" sx={{ width: "48%" }} variant="standard" value={fichaCadastral?.ficha?.pisNisNit || ''} />
                                        <TextField label="CNH" sx={{ width: "48%" }} variant="standard" value={fichaCadastral?.ficha?.cnh || ''} />
                                    </div>
                                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between", gap: "15px", marginTop: "15px" }}>
                                        <TextField label="Estado emissão CNH" sx={{ width: "48%" }} variant="standard" value={fichaCadastral?.ficha?.estadoEmissaoCnh || ''} />
                                        <TextField label="Naturalidade" sx={{ width: "48%" }} variant="standard" value={fichaCadastral?.ficha?.naturalidade || ''} />
                                    </div>
                                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between", gap: "15px", marginTop: "15px" }}>
                                        <TextField label="Endereço" sx={{ width: "100%" }} variant="standard" value={`${fichaCadastral?.endereco?.Endereco}, ${fichaCadastral?.endereco?.Numero} - ${fichaCadastral?.endereco?.Cidade}, ${fichaCadastral?.endereco?.Estado}, ${fichaCadastral?.endereco?.Cep} ${fichaCadastral?.endereco?.Complemento}` || ''} />
                                    </div>
                                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between", gap: "15px", marginTop: "15px" }}>
                                        <TextField label="Estado Civil" sx={{ width: "33%" }} variant="standard" value={fichaCadastral?.ficha?.estadoCivil || ''} />
                                        <TextField label="Regime de bens" sx={{ width: "33%" }} variant="standard" value={fichaCadastral?.ficha?.regimeBens || ''} />
                                        <TextField label="CPF Conjuge" sx={{ width: "33%" }} variant="standard" value={fichaCadastral?.ficha?.cpfConjugue || ''} />
                                    </div>
                                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between", gap: "15px", marginTop: "15px" }}>
                                        <TextField label="CNPJ" sx={{ width: "48%" }} variant="standard" value={fichaCadastral?.ficha?.cnpj || ''} />
                                        <TextField label="Senha Gov" sx={{ width: "48%" }} variant="standard" value={fichaCadastral?.ficha?.senhaGov || ''} />
                                    </div>
                                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between", gap: "15px", marginTop: "15px" }}>
                                        <TextField label="Endereço fiscal" sx={{ width: "100%" }} variant="standard" value={fichaCadastral?.ficha?.enderecoFiscal || ''} />
                                    </div>
                                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between", gap: "15px", marginTop: "15px" }}>
                                        <TextField label="Razão Social" sx={{ width: "100%" }} variant="standard" value={fichaCadastral?.ficha?.razaoSocial || ''} />
                                    </div>
                                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between", gap: "15px", marginTop: "15px" }}>
                                        <TextField label="Nome Fantasia" sx={{ width: "100%" }} variant="standard" value={fichaCadastral?.ficha?.nomeFantasia || ''} />
                                    </div>
                                </div>
                            </Card >

                            <Card style={{ width: "100%", borderRadius: "5px", backgroundColor: "#f7f7f7ff" }}>
                                <div style={{ padding: "15px", width: "100%", borderRadius: "5px", backgroundColor: "#f7f7f7ff", cursor: "pointer" }} onClick={() => {
                                    if (showFichaDocumentos) {
                                        setShowFichaDocumentos(false)
                                    } else {
                                        setShowFichaDocumentos(true)
                                    }
                                }}>
                                    <h2>Ficha de Documentos</h2>
                                    <p>
                                        {!fichaDocumentos ? (
                                            <span style={{ color: "red" }}>
                                                Usuário não enviou todos os documentos
                                            </span>
                                        ) : (
                                            <p>
                                                {fichaDocumentos?.rgCnhFileName !== null &&
                                                    fichaDocumentos?.tituloEleitorFileName !== null &&
                                                    fichaDocumentos?.comprovanteResidenciaFileName !== null ? (
                                                    <span style={{ color: "green" }}>
                                                        Usuário enviou todos os documentos
                                                    </span>
                                                ) : (
                                                    <span style={{ color: "red" }}>
                                                        Usuário não enviou todos os documentos
                                                    </span>
                                                )}
                                            </p>
                                        )}
                                    </p>

                                </div>
                                <Divider />
                                <div style={{ padding: "15px", display: showFichaDocumentos ? "block" : "none", transition: "all 0.3s ease-in-out" }}>
                                    <div style={{ width: "100%", height: "fit-content", padding: "20px", borderRadius: "8px", border: "1px solid #e0e0e0", backgroundColor: "#f9f9f9", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)" }}>
                                        <div style={{ marginBottom: "15px" }}>
                                            <h3 style={{ fontWeight: "600", color: "#333" }}>RG ou CNH</h3>
                                        </div>
                                        <Divider style={{ marginBottom: "15px" }} />
                                        {fichaDocumentos?.rgCnhStatus === "Em Análise" || fichaDocumentos?.rgCnhStatus === "Aprovado" ? (
                                            <div style={{ width: "100%", display: "flex", justifyContent: "center", gap: "20px", marginTop: "20px" }}>
                                                {/* cnh pode ser imagem ou pdf */}
                                                {fichaDocumentos?.rgCnhFileName?.endsWith(".pdf") ? (
                                                    <iframe
                                                        src={fichaDocumentos?.rgCnhFileName}
                                                        title="RG ou CNH"
                                                        style={{
                                                            width: "48%",
                                                            height: "300px",
                                                            borderRadius: "8px",
                                                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
                                                        }}
                                                    />
                                                ) : (
                                                    <img
                                                        src={fichaDocumentos?.rgCnhFileName}
                                                        alt="RG ou CNH"
                                                        style={{
                                                            width: "48%",
                                                            maxHeight: "300px",
                                                            objectFit: "contain",
                                                            borderRadius: "8px",
                                                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
                                                        }}
                                                        onClick={() => openModal(fichaDocumentos?.rgCnhFileName)}
                                                    />
                                                )}
                                                <div style={{ width: "50%", display: fichaDocumentos?.rgCnhStatus === "Aprovado" ? "none" : "block" }}>
                                                    <TextField
                                                        fullWidth
                                                        id="outlined-multiline-static"
                                                        label="Motivo da reprovação"
                                                        multiline
                                                        rows={4}
                                                        defaultValue="O documento foi reprovado por: ..."
                                                        variant="outlined"
                                                        style={{ marginBottom: "20px", borderRadius: "8px" }}
                                                        value={motivoRejeicaoRgCnh}
                                                        onChange={(e) => setMotivoRejeicaoRgCnh(e.target.value)}
                                                    />
                                                    <div style={{ display: "flex", justifyContent: "space-between", gap: "15px" }}>
                                                        <Button
                                                            variant="contained"
                                                            size="small"
                                                            sx={{
                                                                backgroundColor: "red",
                                                                '&:hover': { backgroundColor: "#e57373" },
                                                                borderRadius: "6px",
                                                                padding: "6px 12px"
                                                            }}
                                                            onClick={() => handleRejeitarDoc("rgCnh")}
                                                        >
                                                            Reprovar Documento
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            size="small"
                                                            sx={{
                                                                backgroundColor: "green",
                                                                '&:hover': { backgroundColor: "#81c784" },
                                                                borderRadius: "6px",
                                                                padding: "6px 12px"
                                                            }}
                                                            onClick={() => handleAceitarDoc("rgCnh")}

                                                        >
                                                            Aceitar Documento
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <p>Usuário não enviou o documento.</p>
                                        )}
                                    </div>



                                    <div style={{ width: "100%", height: "fit-content", marginTop: "20px", padding: "20px", borderRadius: "8px", border: "1px solid #e0e0e0", backgroundColor: "#f9f9f9", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)" }}>
                                        <div style={{ marginBottom: "15px" }}>
                                            <h3 style={{ fontWeight: "600", color: "#333" }}>Titulo de Eleitor</h3>
                                        </div>
                                        <Divider style={{ marginBottom: "15px" }} />
                                        {fichaDocumentos?.tituloEleitorStatus === "Em Análise" || fichaDocumentos?.tituloEleitorStatus === "Aprovado" ? (
                                            <div style={{ width: "100%", display: "flex", justifyContent: "center", gap: "20px", marginTop: "20px" }}>
                                                {/* titulo de eleitor pode ser imagem ou pdf */}
                                                {fichaDocumentos?.tituloEleitorFileName?.endsWith(".pdf") ? (
                                                    <iframe
                                                        src={fichaDocumentos?.tituloEleitorFileName}
                                                        title="Titulo de Eleitor"
                                                        style={{
                                                            width: "48%",
                                                            height: "300px",
                                                            borderRadius: "8px",
                                                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
                                                        }}
                                                    />
                                                ) : (
                                                    <img
                                                        src={fichaDocumentos?.tituloEleitorFileName}
                                                        alt="Titulo de Eleitor"
                                                        style={{
                                                            width: "48%",
                                                            maxHeight: "300px",
                                                            objectFit: "contain",
                                                            borderRadius: "8px",
                                                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
                                                        }}
                                                        onClick={() => openModal(fichaDocumentos?.tituloEleitorFileName)}
                                                    />
                                                )}
                                                <div style={{ width: "50%", display: fichaDocumentos?.tituloEleitorStatus === "Aprovado" ? "none" : "block" }}>
                                                    <TextField
                                                        fullWidth
                                                        id="outlined-multiline-static"
                                                        label="Motivo da reprovação"
                                                        multiline
                                                        rows={4}
                                                        defaultValue="O documento foi reprovado por: ..."
                                                        variant="outlined"
                                                        style={{ marginBottom: "20px", borderRadius: "8px" }}
                                                        value={motivoRejeicaoTituloEleitor}
                                                        onChange={(e) => setMotivoRejeicaoTituloEleitor(e.target.value)}
                                                    />
                                                    <div style={{ display: "flex", justifyContent: "space-between", gap: "15px" }}>
                                                        <Button
                                                            variant="contained"
                                                            size="small"
                                                            sx={{
                                                                backgroundColor: "red",
                                                                '&:hover': { backgroundColor: "#e57373" },
                                                                borderRadius: "6px",
                                                                padding: "6px 12px"
                                                            }}
                                                            onClick={() => handleRejeitarDoc("tituloEleitor")}
                                                        >
                                                            Reprovar Documento
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            size="small"
                                                            sx={{
                                                                backgroundColor: "green",
                                                                '&:hover': { backgroundColor: "#81c784" },
                                                                borderRadius: "6px",
                                                                padding: "6px 12px"
                                                            }}
                                                            onClick={() => handleAceitarDoc("tituloEleitor")}

                                                        >
                                                            Aceitar Documento
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <p>Usuário não enviou o documento.</p>
                                        )}
                                    </div>




                                    <div style={{ width: "100%", height: "fit-content", marginTop: "20px", padding: "20px", borderRadius: "8px", border: "1px solid #e0e0e0", backgroundColor: "#f9f9f9", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)" }}>
                                        <div style={{ marginBottom: "15px" }}>
                                            <h3 style={{ fontWeight: "600", color: "#333" }}>Comprovante de Residência</h3>
                                        </div>
                                        <Divider style={{ marginBottom: "15px" }} />
                                        {fichaDocumentos?.comprovanteResidenciaStatus === "Em Análise" || fichaDocumentos?.comprovanteResidenciaStatus === "Aprovado" ? (
                                            <div style={{ width: "100%", display: "flex", justifyContent: "center", gap: "20px", marginTop: "20px" }}>
                                                {fichaDocumentos?.comprovanteResidenciaFileName?.endsWith(".pdf") ? (
                                                    <iframe
                                                        src={fichaDocumentos?.comprovanteResidenciaFileName}
                                                        title="RG ou CNH"
                                                        style={{
                                                            width: "48%",
                                                            height: "300px",
                                                            borderRadius: "8px",
                                                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
                                                        }}
                                                    />
                                                ) : (
                                                    <img
                                                        src={fichaDocumentos?.comprovanteResidenciaFileName}
                                                        alt="RG ou CNH"
                                                        style={{
                                                            width: "48%",
                                                            maxHeight: "300px",
                                                            objectFit: "contain",
                                                            borderRadius: "8px",
                                                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
                                                        }}
                                                        onClick={() => openModal(fichaDocumentos?.comprovanteResidenciaFileName)}
                                                    />
                                                )}
                                                <div style={{ width: "50%", display: fichaDocumentos?.comprovanteResidenciaStatus === "Aprovado" ? "none" : "block" }}>
                                                    <TextField
                                                        fullWidth
                                                        id="outlined-multiline-static"
                                                        label="Motivo da reprovação"
                                                        multiline
                                                        rows={4}
                                                        defaultValue="O documento foi reprovado por: ..."
                                                        variant="outlined"
                                                        style={{ marginBottom: "20px", borderRadius: "8px" }}
                                                        value={motivoRejeicaoComprovanteEndereco}
                                                        onChange={(e) => setMotivoRejeicaoComprovanteEndereco(e.target.value)}
                                                    />
                                                    <div style={{ display: "flex", justifyContent: "space-between", gap: "15px" }}>
                                                        <Button
                                                            variant="contained"
                                                            size="small"
                                                            sx={{
                                                                backgroundColor: "red",
                                                                '&:hover': { backgroundColor: "#e57373" },
                                                                borderRadius: "6px",
                                                                padding: "6px 12px"
                                                            }}
                                                            onClick={() => handleRejeitarDoc("comprovanteResidencia")}
                                                        >
                                                            Reprovar Documento
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            size="small"
                                                            sx={{
                                                                backgroundColor: "green",
                                                                '&:hover': { backgroundColor: "#81c784" },
                                                                borderRadius: "6px",
                                                                padding: "6px 12px"
                                                            }}
                                                            onClick={() => handleAceitarDoc("comprovanteResidencia")}

                                                        >
                                                            Aceitar Documento
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <p>Usuário não enviou o documento.</p>
                                        )}
                                    </div>


                                </div>
                            </Card >

                            <Card style={{ width: "100%", borderRadius: "5px", backgroundColor: "#f7f7f7ff" }}>
                                <div style={{ padding: "15px" }}>
                                    <h2>Informações do usuário</h2>
                                </div>
                                <Divider />
                                <div style={{ padding: "15px" }}>
                                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between", gap: "15px" }}>
                                        <TextField label="Nome" sx={{ width: "48%" }} variant="standard" value={userInfo?.Nome || ''} onChange={(e) => setUserInfo({ ...userInfo, Nome: e.target.value })} />
                                        <TextField label="Email" sx={{ width: "48%" }} variant="standard" value={userInfo?.Email || ''} onChange={(e) => setUserInfo({ ...userInfo, Email: e.target.value })} />
                                    </div>
                                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between", gap: "15px", marginTop: "15px" }}>
                                        <TextField label="CPF" sx={{ width: "48%" }} variant="standard" value={MascaraCpf(userInfo?.Cpf)} onChange={e => setUserInfo({ ...userInfo, Cpf: e.target.value.replaceAll(/\D/g, '') })} inputProps={{ maxLength: 14 }} />
                                        <TextField label="Telefone" sx={{ width: "48%" }} variant="standard" value={MascaraTelefone(userInfo?.Telefone)} onChange={e => setUserInfo({ ...userInfo, Telefone: e.target.value.replaceAll(/\D/g, '') })} inputProps={{ maxLength: 14 }} />
                                    </div>
                                </div>
                                <div style={{ padding: "15px", backgroundColor: "#ffffffff", borderRadius: "0 0 5px 5px", marginTop: "20px", display: "flex", justifyContent: "flex-end" }}>
                                    <Button variant="contained" disabled size="small" sx={{ backgroundColor: "#0b243d" }} onClick={(handleSaveUserInfo)}>Salvar alterações</Button>
                                </div>
                            </Card >

                            <Card style={{ width: "100%", borderRadius: "5px", backgroundColor: "#f7f7f7ff" }}>
                                <div style={{ padding: "15px" }}>
                                    <h2>Certificado Digital</h2>
                                </div>
                                <Divider />
                                <div style={{ padding: "15px" }}>
                                    <Typography variant="body1" sx={{ mb: 2 }}>
                                        {certificado ? (
                                            "Cliente possui um certificado digital ativo. Para atualizá-lo, envie um novo arquivo abaixo."
                                        ) : (
                                            <>
                                                <span style={{ color: "#f44336" }}>
                                                    Cliente não possui um certificado digital ativo. Por favor, envie seu certificado.
                                                </span><br />
                                                <span style={{ color: "black", fontWeight: "bold", fontSize: "12px" }}>
                                                    Para enviar o certificado é necessário cadastrar a empresa.
                                                </span>
                                            </>
                                        )}
                                    </Typography>

                                    {/* Certificado ativo */}
                                    {certificado && (
                                        <Box
                                            sx={{
                                                mb: 3,
                                                p: 3,
                                                borderRadius: "16px",
                                                border: "1px solid rgba(255,200,69,0.35)",
                                                background: "linear-gradient(135deg, #FFFDF5 0%, #FFF7D6 100%)",
                                                boxShadow: "0 8px 20px rgba(255, 200, 69, 0.12)",
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 2,
                                                    mb: 2,
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        width: 50,
                                                        height: 50,
                                                        borderRadius: "50%",
                                                        background: "#ffc845",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        color: "#fff",
                                                    }}
                                                >
                                                    <VerifiedUserIcon fontSize="large" />
                                                </Box>

                                                <Box>
                                                    <Typography
                                                        sx={{
                                                            fontWeight: 700,
                                                            fontSize: "1.1rem",
                                                            color: "#8a6100",
                                                        }}
                                                    >
                                                        Certificado Digital
                                                    </Typography>

                                                    <Typography
                                                        sx={{
                                                            color: certificado?.ativo ? "#2E7D32" : "#D32F2F",
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        {certificado?.ativo ? "● Ativo" : "● Inativo"}
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            <Box
                                                sx={{
                                                    display: "grid",
                                                    gridTemplateColumns: {
                                                        xs: "1fr",
                                                        md: "repeat(2, 1fr)",
                                                    },
                                                    gap: 2,
                                                }}
                                            >
                                                <Box>
                                                    <Typography variant="caption" color="text.secondary">
                                                        Titular
                                                    </Typography>
                                                    <Typography fontWeight={600}>
                                                        {certificado?.titular || "-"}
                                                    </Typography>
                                                </Box>

                                                <Box>
                                                    <Typography variant="caption" color="text.secondary">
                                                        Emissor
                                                    </Typography>
                                                    <Typography fontWeight={600}>
                                                        {certificado?.emissor || "-"}
                                                    </Typography>
                                                </Box>

                                                <Box>
                                                    <Typography variant="caption" color="text.secondary">
                                                        Data de Expiração
                                                    </Typography>
                                                    <Typography fontWeight={600}>
                                                        {certificado?.dataExpiracao
                                                            ? new Date(certificado.dataExpiracao).toLocaleDateString("pt-BR")
                                                            : "-"}
                                                    </Typography>
                                                </Box>

                                                <Box>
                                                    <Typography variant="caption" color="text.secondary">
                                                        Status
                                                    </Typography>
                                                    <Typography
                                                        fontWeight={700}
                                                        color={certificado?.ativo ? "success.main" : "error.main"}
                                                    >
                                                        {certificado?.ativo ? "Ativo" : "Inativo"}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Box>
                                    )}
                                    {/* Upload do certificado */}
                                    <Typography sx={{ mb: 1 }}>
                                        Arquivo do Certificado (.pfx ou .p12):
                                    </Typography>
                                    <Box
                                        onDragOver={handleDragOver}
                                        onDragLeave={handleDragLeave}
                                        onDrop={handleDrop}
                                        onClick={() => fileInputRef.current.click()}
                                        sx={{
                                            border: "2px dashed #ccc",
                                            borderRadius: 2,
                                            p: 4,
                                            textAlign: "center",
                                            cursor: "pointer",
                                            borderColor: isDragging ? "#ffc845" : "#ccc",
                                            backgroundColor: isDragging ? "#fffbe6" : "transparent",
                                            transition: "all 0.2s ease",
                                        }}
                                    >
                                        {file ? (
                                            <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                                {file.name}
                                            </Typography>
                                        ) : (
                                            <>
                                                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                                    Arraste e solte o arquivo do certificado aqui
                                                </Typography>
                                                <Typography variant="body2" sx={{ my: 1 }}>
                                                    ou
                                                </Typography>
                                                <Button variant="outlined" onClick={() => fileInputRef.current.click()}>
                                                    Procurar Arquivo
                                                </Button>
                                            </>
                                        )}
                                        <input
                                            disabled={!empresa}
                                            type="file"
                                            accept=".pfx,.p12"
                                            ref={fileInputRef}
                                            onChange={handleFileSelect}
                                            style={{ display: "none" }}
                                        />
                                    </Box>

                                    {/* Senha do certificado */}
                                    <FormControl sx={{ mt: 3 }} fullWidth size="small" variant="outlined" autoComplete="off">
                                        <InputLabel htmlFor="outlined-adornment-password">Senha do Certificado</InputLabel>
                                        <OutlinedInput
                                            id="outlined-adornment-password"
                                            name="fakepassword"
                                            value={senha}
                                            disabled={!empresa}
                                            onChange={(e) => setSenha(e.target.value)}
                                            placeholder="Digite a senha do seu certificado"
                                            type={showPassword ? "text" : "password"}
                                            autoComplete="new-password"
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={handleClickShowPassword}
                                                        onMouseDown={handleMouseDownPassword}
                                                        edge="end"
                                                        aria-label="toggle password visibility"
                                                    >
                                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                            label="Senha do Certificado"
                                        />
                                        <FormHelperText>
                                            A senha é necessária para validar o arquivo do certificado.
                                        </FormHelperText>
                                    </FormControl>
                                    {/* E-mail */}
                                    <FormControl sx={{ mt: 3 }} fullWidth size="small" variant="outlined">
                                        <InputLabel>E-mail para notificação</InputLabel>
                                        <OutlinedInput
                                            value={userInfo?.Email || ''}
                                            disabled
                                            placeholder="Digite seu e-mail"
                                            type="email"
                                            autoComplete="off"
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <EmailIcon />
                                                </InputAdornment>
                                            }
                                            label="E-mail para notificação"
                                        />
                                        <FormHelperText>
                                            Enviaremos notificações para este e-mail quando o certificado estiver próximo do vencimento.
                                        </FormHelperText>
                                    </FormControl>
                                </div>
                                <div style={{ padding: "15px", backgroundColor: "#ffffffff", borderRadius: "0 0 5px 5px", marginTop: "20px", display: "flex", justifyContent: "flex-end" }}>
                                    <Button disabled={!empresa} variant="contained" size="small" sx={{ backgroundColor: "#0b243d" }} onClick={handleSaveCertificado} loading={certificadoLoading}>Salvar certificado</Button>
                                </div>
                            </Card >

                            <Card style={{ width: "100%", borderRadius: "5px", backgroundColor: "#f7f7f7ff" }}>
                                <div style={{ padding: "15px" }}>
                                    <h2>Informações da Empresa</h2>
                                </div>
                                <Divider />
                                <div style={{ padding: "15px" }}>
                                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between", gap: "15px" }}>
                                        <TextField label="CNPJ" sx={{ width: "30%" }} value={MascaraCnpj(cnpjEmpresa)} onChange={(e) => setCnpjEmpresa(TirarMascara(e.target.value))} variant="standard" inputProps={{ maxLength: 18 }} />
                                        <TextField label="Inscrição Estadual" sx={{ width: "30%" }} value={(inscricaoEstadualEmpresa)} onChange={e => setInscricaoEstadualEmpresa(TirarMascara(e.target.value))} variant="standard" />
                                        <TextField label="Inscrição Municipal" sx={{ width: "30%" }} value={(inscricaoMunicipalEmpresa)} onChange={e => setInscricaoMunicipalEmpresa(TirarMascara(e.target.value))} variant="standard" />
                                    </div>
                                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between", gap: "15px", marginTop: "15px" }}>
                                        <TextField label="Razão Social" sx={{ width: "48%" }} value={razaoSocialEmpresa} variant="standard" onChange={e => setRazaoSocialEmpresa(e.target.value)} />
                                        <TextField label="Nome Fantasia" sx={{ width: "48%" }} value={nomeFantasiaEmpresa} variant="standard" onChange={e => setNomeFantasiaEmpresa(e.target.value)} />
                                    </div>
                                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between", gap: "15px", marginTop: "15px" }}>
                                        <TextField label="E-mail" sx={{ width: "48%" }} value={emailEmpresa} variant="standard" onChange={e => setEmailEmpresa(e.target.value)} />
                                        <TextField label="Telefone" sx={{ width: "22%" }} value={MascaraTelefone(telefoneEmpresa)} variant="standard" onChange={e => setTelefoneEmpresa(TirarMascara(e.target.value))} inputProps={{ maxLength: 14 }} />
                                        <TextField label="Celular" sx={{ width: "22%" }} value={MascaraCelular(celularEmpresa)} variant="standard" onChange={e => setCelularEmpresa(TirarMascara(e.target.value))} inputProps={{ maxLength: 14 }} />
                                    </div>
                                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between", gap: "15px", marginTop: "15px" }}>
                                        <TextField label="CEP" sx={{ width: "20%" }} value={MascaraCep(cepEmpresa)} variant="standard" onChange={e => handleCepChange(e)} inputProps={{ maxLength: 9 }} />
                                        <TextField label="Endereço" disabled sx={{ width: "65%" }} value={enderecoEmpresa} variant="standard" onChange={e => setEnderecoEmpresa(e.target.value)} />
                                        <TextField label="Nª" sx={{ width: "10%" }} value={numeroEmpresa || ''} variant="standard" onChange={e => setNumeroEmpresa(e.target.value)} />
                                    </div>
                                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between", gap: "15px", marginTop: "15px" }}>
                                        <TextField label="País" sx={{ width: "23%" }} disabled value={paisEmpresa} variant="standard" onChange={e => setPaisEmpresa(e.target.value)} />
                                        <TextField label="Estado" sx={{ width: "23%" }} disabled value={estadoEmpresa} variant="standard" onChange={e => setEstadoEmpresa(e.target.value)} />
                                        <TextField label="Cidade" sx={{ width: "23%" }} disabled value={cidadeEmpresa} variant="standard" onChange={e => setCidadeEmpresa(e.target.value)} />
                                        <TextField label="Bairro" sx={{ width: "23%" }} disabled value={bairroEmpresa} variant="standard" onChange={e => setBairroEmpresa(e.target.value)} />
                                    </div>
                                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between", gap: "15px", marginTop: "15px" }}>
                                        <FormControl variant="standard" sx={{ width: "20%" }}>
                                            <InputLabel id="demo-simple-select-standard-label">Regime Tributário</InputLabel>
                                            <Select
                                                value={regimeTributarioEmpresa}
                                                label="Regime Tributário"
                                                onChange={e => setRegimeTributarioEmpresa(e.target.value)}
                                            >
                                                <MenuItem value={"simplesNacional"}>Simples Nacional</MenuItem>
                                                <MenuItem value={"simplesNacionalExcessoSublimite"}>Simples Nacional — Excesso de sublimite de receita bruta</MenuItem>
                                                <MenuItem value={"regimeNormal"}>Regime Normal (Lucro Presumido ou Lucro Real)</MenuItem>
                                                <MenuItem value={"simplesNacionalMEI"}>Simples Nacional - MEI</MenuItem>
                                            </Select>
                                        </FormControl>
                                        <FormControl variant="standard" sx={{ width: "25%" }}>
                                            <InputLabel id="demo-simple-select-standard-label">Regime Tributário Especial</InputLabel>
                                            <Select
                                                value={regimeTributarioEspecialEmpresa}
                                                label="Regime Tributário Especial"
                                                onChange={e => setRegimeTributarioEspecialEmpresa(e.target.value)}
                                            >
                                                <MenuItem value={"municipalMicroenterprise"}>Microempresa Municipal</MenuItem>
                                                <MenuItem value={"estimate"}>Estimativa</MenuItem>
                                                <MenuItem value={"societyOfProfessionals"}>Sociedade de Profissionais</MenuItem>
                                                <MenuItem value={"cooperative"}>Cooperativa</MenuItem>
                                                <MenuItem value={"individualMicroenterprise"}>Microempresário Individual (MEI)</MenuItem>
                                                <MenuItem value={"microenterpriseAndSmallBusiness"}>Microempresário e Empresa de Pequeno Porte (ME EPP)</MenuItem>
                                                <MenuItem value={"noSpecialRegime"}>Sem Regime Especial</MenuItem>
                                                <MenuItem value={"others"}>Outros</MenuItem>
                                            </Select>
                                        </FormControl>
                                        <FormControl variant="standard" sx={{ width: "53%" }}>
                                            <InputLabel id="demo-simple-select-standard-label">Regime de Apuração dos Tributos do Simples Nacional</InputLabel>
                                            <Select
                                                value={regimeApuracaoTributariaEmpresa}
                                                label="Simples Nacional"
                                                onChange={e => setRegimeApuracaoTributariaEmpresa(e.target.value)}
                                            >
                                                <MenuItem value={"federalAndMunicipalBySimplesNacional"}>Regime de apuração dos tributos federais e municipal pelo Simples Nacional</MenuItem>
                                                <MenuItem value={"federalBySimplesAndIssqnByNfse"}>Regime de apuração dos tributos federais pelo Simples Nacional e o ISSQN pela NFS-e conforme legislação municipal</MenuItem>
                                                <MenuItem value={"federalAndMunicipalByNfse"}>Regime de apuração dos tributos federais e municipal pela NFS-e conforme legislações federal e municipal</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                </div>
                                <div style={{ padding: "15px", backgroundColor: "#ffffffff", borderRadius: "0 0 5px 5px", marginTop: "32px", display: "flex", justifyContent: "flex-end" }}>
                                    <Button variant="contained" size="small" sx={{ backgroundColor: "#0b243d" }} onClick={handleSaveCompany} loading={empresaLoading}>Salvar alterações</Button>
                                </div>
                            </Card >

                            <Card style={{ width: "100%", borderRadius: "5px", backgroundColor: "#f7f7f7ff" }}>
                                <div style={{ padding: "15px" }}>
                                    <h2>Configurações da Empresa</h2>
                                </div>
                                <Divider />
                                <div style={{ padding: "15px" }}>
                                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between", gap: "15px" }}>
                                        <TextField disabled={!empresa} label="Série" sx={{ width: "48%" }} value={(serie)} onChange={e => setSerie(e.target.value)} variant="standard" />
                                        <TextField disabled={!empresa} label="Número do próximo RPS/DPS ou NFs-e" sx={{ width: "48%" }} value={(nextNumeroNota)} onChange={e => setNextNumeroNota(e.target.value)} variant="standard" />
                                    </div>
                                </div>
                                <div style={{ padding: "15px", backgroundColor: "#ffffffff", borderRadius: "0 0 5px 5px", marginTop: "32px", display: "flex", justifyContent: "flex-end" }}>
                                    <Button disabled={!empresa} variant="contained" size="small" sx={{ backgroundColor: "#0b243d" }} onClick={handleSaveCompanyConfig} loading={empresaLoading}>Salvar alterações</Button>
                                </div>
                            </Card>
                            <Card style={{ width: "100%", borderRadius: "5px", backgroundColor: "#f7f7f7ff" }}>
                                <div style={{ padding: "15px" }}>
                                    <h2>Serviços do usuário</h2>
                                </div>
                                <Divider />
                                <div style={{ padding: "15px" }}>
                                    <Typography variant="body1" sx={{ mb: 2 }}>
                                        Adicione os principais serviços desse cliente, para facilitar a emissão de notas fiscais de serviço. Caso o serviço não esteja na lista, acione o TI.
                                    </Typography>
                                    {/* Tabela */}
                                    <Card sx={{ borderRadius: "16px" }}>
                                        <TableContainer component={Paper} sx={{ borderRadius: "12px" }}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell><strong>ID</strong></TableCell>
                                                        <TableCell><strong>Código</strong></TableCell>
                                                        <TableCell><strong>Discriminação</strong></TableCell>
                                                        <TableCell><strong>Ação</strong></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {servicos.length > 0 ? (
                                                        servicos.map((servico) => (
                                                            <TableRow key={servico.idServico}>
                                                                <TableCell>#{servico.idServico}</TableCell>
                                                                <TableCell>{servico.codigo.replace(/\D/g, "").match(/.{1,2}/g)?.join(".") || ""}</TableCell>
                                                                <TableCell> {servico.discriminacao}</TableCell>
                                                                <TableCell>
                                                                    <IconButton onClick={() => handleDeleteService(servico)}>
                                                                        <DeleteIcon sx={{ color: "red" }} />
                                                                    </IconButton>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))
                                                    ) : (
                                                        <TableRow>
                                                            <TableCell colSpan={8} align="center">
                                                                Nenhum serviço encontrado.
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Card>
                                    <div style={{ marginTop: "30px", display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                        <Autocomplete
                                            size="small"
                                            disablePortal
                                            options={servicesCode}
                                            getOptionLabel={(option) => option.label}
                                            value={servicesCode.find((option) => option.code === servicoASerAdicionado?.code) || null}
                                            onChange={(event, newValue) => {
                                                if (newValue) {
                                                    console.log(newValue);
                                                    setServicoASerAdicionado(newValue);
                                                }
                                            }}
                                            fullWidth
                                            renderInput={(params) => <TextField {...params} label="Serviço" />}
                                        />
                                    </div>
                                </div>
                                <div style={{ padding: "15px", backgroundColor: "#ffffffff", borderRadius: "0 0 5px 5px", marginTop: "32px", display: "flex", justifyContent: "flex-end" }}>
                                    <Button variant="contained" size="small" sx={{ backgroundColor: "#0b243d" }} onClick={handleSaveServico} loading={servicoLoading}>Adicionar Serviço</Button>
                                </div>
                            </Card >

                            <Card style={{ width: "100%", borderRadius: "5px", backgroundColor: "#f7f7f7ff" }}>
                                <div style={{ padding: "15px" }}>
                                    <h2>Emitir Nota Fiscal (Serviço)</h2>
                                    <span style={{ fontSize: "14px", color: "black" }}>Limite de emissão para este usuário: {qtdEmitidas}/{limiteNotas} </span>
                                </div>
                                <Divider />
                                <div style={{ padding: "15px" }}>
                                    <div style={{ marginTop: "20px" }}>
                                        <h3>Prestador</h3>
                                        <Divider />
                                        <div style={{ marginTop: "10px" }}>
                                            <p style={{ fontSize: "14px" }}>Dados do prestador:</p>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                                            <TextField size='small' label="CPF ou CNPJ" disabled required variant="outlined" value={MascaraCnpj(cnpjEmpresa)} style={{ width: '49%' }} />
                                            <TextField size='small' label="Razão Social" disabled required variant="outlined" value={razaoSocialEmpresa} style={{ width: '49%' }} />
                                        </div>
                                    </div>
                                    <div style={{ marginTop: "20px" }}>
                                        <h3>Tomador</h3>
                                        <Divider />
                                        <FormControlLabel control={<Checkbox defaultChecked={hasTomador} onChange={(e) => setHasTomador(e.target.checked)} />} label="Nota possui tomador?" />
                                        {hasTomador ? (
                                            <div style={{ marginTop: "10px" }}>
                                                <div style={{ marginBottom: "10px" }}>
                                                    <p style={{ fontSize: "14px" }}>Preencha os dados do tomador:</p>
                                                </div>
                                                <div style={{ marginTop: "10px", display: 'flex', justifyContent: 'space-between' }}>
                                                    <TextField size='small' label="Nome" required variant="outlined" style={{ width: '49%' }} value={nomeTomador} onChange={e => setNomeTomador(e.target.value)} />
                                                    <TextField size='small' label="CPF ou CNPJ" required variant="outlined" style={{ width: '49%' }} value={cpfCnpjTomador} onChange={e => handleCnpjTomador(e)} />
                                                </div>
                                                <div style={{ marginTop: "10px", display: 'flex', justifyContent: 'space-between' }}>
                                                    <TextField size='small' label="E-mail" variant="outlined" style={{ width: '49%' }} value={emailTomador} onChange={e => setEmailTomador(e.target.value)} />
                                                    <TextField size='small' label="Telefone" variant="outlined" style={{ width: '49%' }} value={telefoneTomador} onChange={e => setTelefoneTomador(e.target.value)} />
                                                </div>
                                                <div style={{ marginTop: "10px", display: 'flex', justifyContent: 'space-between' }}>
                                                    <TextField size='small' label="CEP" variant="outlined" style={{ width: '30%' }} value={MascaraCep(cepTomador)} onChange={e => handleCepTomador(e)} />
                                                    <TextField disabled size='small' label="Endereço" variant="outlined" style={{ width: '59%' }} value={enderecoTomador} onChange={e => setEnderecoTomador(e.target.value)} />
                                                    <TextField size='small' label="Nª" variant="outlined" style={{ width: '10%' }} value={numeroTomador} onChange={e => setNumeroTomador(e.target.value)} />
                                                </div>
                                                <div style={{ marginTop: "10px", display: 'flex', justifyContent: 'space-between' }}>

                                                    <TextField disabled size='small' label="País" variant="outlined" style={{ width: '24%' }} value={paisTomador} onChange={e => setPaisTomador(e.target.value)} />
                                                    <TextField disabled size='small' label="Estado" variant="outlined" style={{ width: '24%' }} value={estadoTomador} onChange={e => setEstadoTomador(e.target.value)} />
                                                    <TextField disabled size='small' label="Cidade" variant="outlined" style={{ width: '24%' }} value={cidadeTomador} onChange={e => setCidadeTomador(e.target.value)} />
                                                    <TextField disabled size='small' label="Bairro" variant="outlined" style={{ width: '24%' }} value={bairroTomador} onChange={e => setBairroTomador(e.target.value)} />
                                                </div>
                                            </div>
                                        ) : (
                                            <p style={{ fontSize: "14px", color: "orange" }}>Nota fiscal de serviço sem tomador.</p>
                                        )}
                                    </div>
                                    <div style={{ marginTop: "20px" }}>
                                        <h3>Serviço</h3>
                                        <Divider />
                                        <div style={{ marginTop: "10px" }}>
                                            <div style={{ marginTop: "30px", display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                <FormControl size='small' fullWidth>
                                                    <InputLabel id="demo-simple-select-label">Selecione o serviço</InputLabel>
                                                    <Select
                                                        value={codigo}
                                                        label="Selecione o serviço"
                                                        onChange={e => setCodigo(e.target.value)}
                                                    >
                                                        {servicos ? servicos.map(servico => (
                                                            <MenuItem key={servico.codigo} value={servico.codigo}>
                                                                {servico.codigo.replace(/\D/g, "").match(/.{1,2}/g)?.join(".") || ""} - {servico.discriminacao}
                                                            </MenuItem>
                                                        )) : null}
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            <div style={{ marginTop: "10px", display: 'flex', justifyContent: 'space-between' }}>
                                                <TextField size='small' multiline rows={2} label="Descrição do Serviço" variant="outlined" style={{ width: '100%' }} value={descricaoDoServico} onChange={e => setDescricaoDoServico(e.target.value)} />
                                            </div>
                                            <div style={{ marginTop: "30px", display: 'flex', justifyContent: 'space-between' }}>
                                                <NumericFormat customInput={TextField} allowLeadingZeros prefix="R$ " valueIsNumericString decimalSeparator="," decimalScale={2} size='small' label="Valor do Serviço" value={valorServico} onChange={e => { setValorServico(e.target.value); setBaseCalculo(e.target.value); setValorLiquido(e.target.value); }} variant="outlined" style={{ width: '49%' }} />
                                                <TextField size='small' label="Alíquota Simples Nacional / Mês" variant="outlined" style={{ width: '49%' }} value={alqSimplesNacional} onChange={e => {
                                                    // permitir apenas numeros e virgula
                                                    const value = e.target.value.replace(/[^0-9,]/g, '').trim();
                                                    setAlqSimplesNacional(value);
                                                }} />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ padding: "15px" }}>
                                    <Box
                                        onClick={() => handleShowInformation()}
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                            cursor: "pointer",
                                            color: "primary.main",
                                            fontWeight: 600,
                                            userSelect: "none",
                                            width: "fit-content",
                                            transition: "0.2s",
                                            "&:hover": {
                                                color: "primary.dark",
                                            },
                                        }}
                                    >
                                        {showConfigAvancadaNfse ? <ExpandLess /> : <ExpandMore />}

                                        <Typography variant="body2" fontWeight={600}>
                                            {showConfigAvancadaNfse
                                                ? "Ocultar configurações avançadas"
                                                : "Exibir configurações avançadas"}
                                        </Typography>
                                    </Box>
                                    <div style={{ justifyContent: 'space-between', flexDirection: 'column', gap: '16px', marginTop: '16px', display: showConfigAvancadaNfse ? 'flex' : 'none', transition: 'all 0.3s ease-in-out' }}>
                                        <Box sx={{ mt: 3, p: 3, border: "1px solid #E5E7EB", borderRadius: 2, bgcolor: "#FAFAFA", }} >
                                            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2, }} >
                                                Informações da Nota
                                            </Typography>

                                            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, }}  >
                                                <LocalizationProvider
                                                    dateAdapter={AdapterDateFns}
                                                    adapterLocale={ptBR}
                                                >
                                                    <DatePicker
                                                        label="Data de Competência"
                                                        value={dataCompetencia}
                                                        onChange={(newValue) => setDataCompetencia(newValue)}
                                                        format="dd/MM/yyyy"
                                                        slotProps={{
                                                            textField: {
                                                                size: "small",
                                                                sx: {
                                                                    flex: "1 1 220px",
                                                                },
                                                            },
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                                <NumericFormat disabled customInput={TextField} allowLeadingZeros prefix="R$ " valueIsNumericString decimalSeparator="," decimalScale={2} size="small" label="Deduções (R$)" sx={{ flex: "1 1 180px", }} value={deducoes} onChange={(e) => handleDeducoesChange(e)} />
                                                <TextField disabled size="small" label="Base de Cálculo (R$)" sx={{ flex: "1 1 180px", }} value={baseCalculo} />
                                                <TextField disabled size="small" label="Valor Líquido (R$)" sx={{ flex: "1 1 180px", }} value={valorLiquido} />
                                            </Box>

                                            <Divider sx={{ my: 3 }} />

                                            <TextField
                                                fullWidth
                                                multiline
                                                rows={3}
                                                label="Informações Complementares"
                                                placeholder="Digite observações que deverão constar na NFS-e..."
                                            />
                                        </Box>
                                        {/* <h4>Impostos</h4>
                                        <Divider /> */}
                                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 2, }} >
                                            {/* ISS */}
                                            {/* <Box sx={{ flex: "1 1 260px", minWidth: 250, p: 2, border: "1px solid #E5E7EB", borderRadius: 2, bgcolor: "#FAFAFA", }} >
                                                <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600 }} >
                                                    ISS
                                                </Typography>

                                                <Box sx={{ display: "flex", gap: 1.5 }}>
                                                    <TextField size="small" label="Alíquota (%)" fullWidth onChange={(e) => { setImpostoIssAlq(e.target.value); setImpostoIssValor(handleCalcularImposto(e.target.value)); }} value={impostoIssAlq} />
                                                    <TextField size="small" label="Valor" disabled fullWidth value={impostoIssValor} />
                                                </Box>
                                            </Box> */}

                                            {/* PIS */}
                                            {/* <Box sx={{ flex: "1 1 260px", minWidth: 250, p: 2, border: "1px solid #E5E7EB", borderRadius: 2, bgcolor: "#FAFAFA", }} >
                                                <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600 }} >
                                                    PIS
                                                </Typography>

                                                <Box sx={{ display: "flex", gap: 1.5 }}>
                                                    <TextField size="small" label="Alíquota (%)" fullWidth onChange={(e) => { setImpostoPisAlq(e.target.value); setImpostoPisValor(handleCalcularImposto(e.target.value)); }} value={impostoPisAlq} />
                                                    <TextField size="small" label="Valor" disabled fullWidth value={impostoPisValor} />
                                                </Box>
                                            </Box> */}

                                            {/* COFINS */}
                                            {/* <Box sx={{ flex: "1 1 260px", minWidth: 250, p: 2, border: "1px solid #E5E7EB", borderRadius: 2, bgcolor: "#FAFAFA", }} >
                                                <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600 }} >
                                                    COFINS
                                                </Typography>

                                                <Box sx={{ display: "flex", gap: 1.5 }}>
                                                    <TextField size="small" label="Alíquota (%)" fullWidth onChange={(e) => { setImpostoCofinsAlq(e.target.value); setImpostoCofinsValor(handleCalcularImposto(e.target.value)); }} value={impostoCofinsAlq} />
                                                    <TextField size="small" label="Valor" disabled fullWidth value={impostoCofinsValor} />
                                                </Box>
                                            </Box> */}

                                            {/* CSLL */}
                                            {/* <Box sx={{ flex: "1 1 260px", minWidth: 250, p: 2, border: "1px solid #E5E7EB", borderRadius: 2, bgcolor: "#FAFAFA", }} >
                                                <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600 }} >
                                                    CSLL
                                                </Typography>

                                                <Box sx={{ display: "flex", gap: 1.5 }}>
                                                    <TextField size="small" label="Alíquota (%)" fullWidth onChange={(e) => { setImpostoCsllAlq(e.target.value); setImpostoCsllValor(handleCalcularImposto(e.target.value)); }} value={impostoCsllAlq} />
                                                    <TextField size="small" label="Valor" disabled fullWidth value={impostoCsllValor} />
                                                </Box>
                                            </Box> */}

                                            {/* IR */}
                                            {/* <Box sx={{ flex: "1 1 260px", minWidth: 250, p: 2, border: "1px solid #E5E7EB", borderRadius: 2, bgcolor: "#FAFAFA", }} >
                                                <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600 }} >
                                                    IR
                                                </Typography>

                                                <Box sx={{ display: "flex", gap: 1.5 }}>
                                                    <TextField size="small" label="Alíquota (%)" fullWidth onChange={(e) => { setImpostoIrAlq(e.target.value); setImpostoIrValor(handleCalcularImposto(e.target.value)); }} value={impostoIrAlq} />
                                                    <TextField size="small" label="Valor" disabled fullWidth value={impostoIrValor} />
                                                </Box>
                                            </Box> */}

                                            {/* INSS */}
                                            {/* <Box sx={{ flex: "1 1 260px", minWidth: 250, p: 2, border: "1px solid #E5E7EB", borderRadius: 2, bgcolor: "#FAFAFA", }} >
                                                <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600 }} >
                                                    INSS
                                                </Typography>

                                                <Box sx={{ display: "flex", gap: 1.5 }}>
                                                    <TextField size="small" label="Alíquota (%)" fullWidth onChange={(e) => { setImpostoInssAlq(e.target.value); setImpostoInssValor(handleCalcularImposto(e.target.value)); }} value={impostoInssAlq} />
                                                    <TextField size="small" label="Valor" disabled fullWidth value={impostoInssValor} />
                                                </Box>
                                            </Box> */}
                                        </Box>
                                        <h4>Retenções</h4>
                                        <Divider />
                                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 2, }} >
                                            {/* ISS */}
                                            {/* <Box sx={{ flex: "1 1 230px", minWidth: 220, border: "1px solid #E5E7EB", borderRadius: 2, p: 2, bgcolor: "#FAFAFA", transition: "0.2s", "&:hover": { boxShadow: 2, }, }} >
                                                <FormControl fullWidth>
                                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, }} >
                                                        <FormLabel sx={{ fontWeight: 600 }}>
                                                            Reter ISS
                                                        </FormLabel>
                                                        <Switch color="primary" onChange={(e) => { setReterIss(e.target.checked); setValorIssRetido(''); }} checked={reterIss} />
                                                    </Box>
                                                    <NumericFormat customInput={TextField} allowLeadingZeros prefix="R$ " valueIsNumericString decimalSeparator="," decimalScale={2} fullWidth size="small" label="Valor retido" value={valorIssRetido} onChange={e => setValorIssRetido(e.target.value)} disabled={!reterIss} />
                                                </FormControl>
                                            </Box> */}

                                            {/* PIS */}
                                            {/* <Box sx={{ flex: "1 1 230px", minWidth: 220, border: "1px solid #E5E7EB", borderRadius: 2, p: 2, bgcolor: "#FAFAFA", transition: "0.2s", "&:hover": { boxShadow: 2, }, }} >
                                                <FormControl fullWidth>
                                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, }} >
                                                        <FormLabel sx={{ fontWeight: 600 }}>
                                                            Reter PIS
                                                        </FormLabel>
                                                        <Switch color="primary" onChange={(e) => { setReterPis(e.target.checked); setValorPisRetido(''); }} checked={reterPis} />
                                                    </Box>
                                                    <NumericFormat customInput={TextField} allowLeadingZeros prefix="R$ " valueIsNumericString decimalSeparator="," decimalScale={2} fullWidth size="small" label="Valor retido" value={valorPisRetido} onChange={e => setValorPisRetido(e.target.value)} disabled={!reterPis} />
                                                </FormControl>
                                            </Box> */}

                                            {/* COFINS */}
                                            {/* <Box sx={{ flex: "1 1 230px", minWidth: 220, border: "1px solid #E5E7EB", borderRadius: 2, p: 2, bgcolor: "#FAFAFA", transition: "0.2s", "&:hover": { boxShadow: 2, }, }} >
                                                <FormControl fullWidth>
                                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, }} >
                                                        <FormLabel sx={{ fontWeight: 600 }}>
                                                            Reter COFINS
                                                        </FormLabel>
                                                        <Switch color="primary" onChange={(e) => { setReterCofins(e.target.checked); setValorCofinsRetido(''); }} checked={reterCofins} />
                                                    </Box>
                                                    <NumericFormat customInput={TextField} allowLeadingZeros prefix="R$ " valueIsNumericString decimalSeparator="," decimalScale={2} fullWidth size="small" label="Valor retido" value={valorCofinsRetido} onChange={e => setValorCofinsRetido(e.target.value)} disabled={!reterCofins} />
                                                </FormControl>
                                            </Box> */}

                                            {/* CSLL */}
                                            {/* <Box sx={{ flex: "1 1 230px", minWidth: 220, border: "1px solid #E5E7EB", borderRadius: 2, p: 2, bgcolor: "#FAFAFA", transition: "0.2s", "&:hover": { boxShadow: 2, }, }} >
                                                <FormControl fullWidth>
                                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, }} >
                                                        <FormLabel sx={{ fontWeight: 600 }}>
                                                            Reter CSLL
                                                        </FormLabel>
                                                        <Switch color="primary" onChange={(e) => { setReterCsll(e.target.checked); setValorCsllRetido(''); }} checked={reterCsll} />
                                                    </Box>
                                                    <NumericFormat customInput={TextField} allowLeadingZeros prefix="R$ " valueIsNumericString decimalSeparator="," decimalScale={2} fullWidth size="small" label="Valor retido" value={valorCsllRetido} onChange={e => setValorCsllRetido(e.target.value)} disabled={!reterCsll} />
                                                </FormControl>
                                            </Box> */}

                                            {/* IR */}
                                            <Box sx={{ flex: "1 1 230px", maxWidth: 220, border: "1px solid #E5E7EB", borderRadius: 2, p: 2, bgcolor: "#FAFAFA", transition: "0.2s", "&:hover": { boxShadow: 2, }, }} >
                                                <FormControl fullWidth>
                                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, }} >
                                                        <FormLabel sx={{ fontWeight: 600 }}>
                                                            Reter IR
                                                        </FormLabel>
                                                        <Switch color="primary" onChange={(e) => { setReterIr(e.target.checked); setValorIrRetido(''); }} checked={reterIr} />
                                                    </Box>
                                                    <NumericFormat customInput={TextField} allowLeadingZeros prefix="R$ " valueIsNumericString decimalSeparator="," decimalScale={2} fullWidth size="small" label="Valor retido" value={valorIrRetido} onChange={e => handleIrChange(e)} disabled={!reterIr} />
                                                </FormControl>
                                            </Box>

                                            {/* INSS */}
                                            {/* <Box sx={{ flex: "1 1 230px", minWidth: 220, border: "1px solid #E5E7EB", borderRadius: 2, p: 2, bgcolor: "#FAFAFA", transition: "0.2s", "&:hover": { boxShadow: 2, }, }} >
                                                <FormControl fullWidth>
                                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, }} >
                                                        <FormLabel sx={{ fontWeight: 600 }}>
                                                            Reter INSS
                                                        </FormLabel>
                                                        <Switch color="primary" onChange={(e) => { setReterInss(e.target.checked); setValorInssRetido(''); }} checked={reterInss} />
                                                    </Box>
                                                    <NumericFormat customInput={TextField} allowLeadingZeros prefix="R$ " valueIsNumericString decimalSeparator="," decimalScale={2} fullWidth size="small" label="Valor retido" value={valorInssRetido} onChange={e => setValorInssRetido(e.target.value)} disabled={!reterInss} />
                                                </FormControl>
                                            </Box> */}
                                        </Box>
                                    </div>
                                </div>
                                <div style={{ padding: "15px", backgroundColor: "#ffffffff", borderRadius: "0 0 5px 5px", marginTop: "20px", display: "flex", justifyContent: "flex-end" }}>
                                    <Button variant="contained" size="small" sx={{ backgroundColor: "#0b243d" }} loading={notaLoading} onClick={handleEmitirNota}>Emitir Nota Fiscal</Button>
                                </div>
                            </Card >
                        </div>
                    </div>
                </div>
            </div >
            <ModalImage
                open={modalOpen}
                onClose={closeModal}
                imageUrl={selectedImage}
            />
        </div >
    );
}

export default PerfilUsuario;